import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { useMutation } from "@tanstack/react-query";
import { getRealestateDetails } from "api/realestate.request";
import { IPictures } from "shared/models/interfaces/response/realestate.interface";
import { moneyFormatter } from "@components/property-card/withAdapter";
import VirtualTourDialog from "@components/virtual-tour-dialog";
import { Wrapper } from "./styles";
import AlbumHeader from "./components/AlbumHeader";
import AlbumPictures from "./components/AlbumPictures";
import AlbumFooter from "./components/AlbumFooter";

function AlbumSection(props: { data: any; isCollection: boolean; id: number }) {
  const { data, isCollection, id } = props;
  const user = useAppSelector(({ Auth }) => Auth.user);
  const price = data?.currency.symbol + moneyFormatter.format(data?.price);
  let maximum_price = null;
  let minimum_price = null;

  if (data?.project?.minimum_price && data?.project?.maximum_price) {
    maximum_price =
      `${data.currency.symbol}` +
      moneyFormatter.format(data.project.maximum_price as any);
    minimum_price =
      `${data.currency.symbol}` +
      moneyFormatter.format(data.project.minimum_price as any);
  }

  let cache: any = [];
  const cleanImages = data.pictures.map((picture: any) => {
    if (!cache.includes(picture.pictures)) {
      cache.push(picture.pictures);
      return picture;
    }
    return null;
  });
  const pictures = cleanImages.filter(Boolean);

  const [mainImage, setMainImage] = useState<IPictures>(pictures[0]);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean | null>(data.is_favorite);

  const { mutate } = useMutation(["propertyDetails", id], getRealestateDetails, {
    onSuccess: ({ data: { is_favorite } }) => {
      setIsFavorite(!!is_favorite);
    },
  });

  const handleOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleMainImageChange = (picture: IPictures) => {
    setMainImage(picture);
  };

  useEffect(() => {
    handleMainImageChange(pictures[0]);
  }, [data.id]);

  useEffect(() => {
    if (user) mutate(id);
  }, [user, mutate, id]);

  return (
    <Wrapper>
      <AlbumHeader
        isCollection={isCollection}
        id={id}
        isFavorite={isFavorite}
        onFavoriteChange={setIsFavorite}
        detail={data}
        parent_id={data.parent_id}
      />

      <AlbumPictures
        pictures={pictures}
        mainImage={mainImage}
        onMainImageChange={handleMainImageChange}
        data={data}
      />

      <AlbumFooter
        data={data}
        onTourClick={handleOpen}
        minimum_price={minimum_price}
        maximum_price={maximum_price}
        price={price}
      />

      {Boolean(data.realstate_tour_url) && (
        <VirtualTourDialog
          open={openDialog}
          onClose={handleClose}
          src={data.realstate_tour_url}
        />
      )}
    </Wrapper>
  );
}

export default AlbumSection; 